import * as React from 'react'; 
import { string, element, func, bool, oneOf, oneOfType, any } from 'prop-types';

export default function Button(props){
  return <button 
    className={` ${!props.active && 'bg-white'} border-white shadow ${props.active && 'bg-blue-400 text-white'} ${props.fitContainer ? 'w-full block': ''} rounded p-2 outline-none ${props.fullRound && 'rounded-full'} border-gray-400`} 
    onClick={props.onClick}>
    {props.children}
  </button>
}

Button.propTypes = {
  children: any,
  onClick: func,
  fitContainer: bool,
  active: bool,
}
